import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4ed07c4f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "seo-content-search"
};
const _hoisted_2 = {
  class: "search-wrapper"
};
const _hoisted_3 = {
  class: "push-status-filter"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "btn-title"
}, "Bulk edit", -1));
const _hoisted_5 = {
  class: "export-wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_seo_top_section = _resolveComponent("seo-top-section");
  const _component_app_input = _resolveComponent("app-input");
  const _component_seo_push_status_filter = _resolveComponent("seo-push-status-filter");
  const _component_feature = _resolveComponent("feature");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_content_export_drop_down = _resolveComponent("content-export-drop-down");
  const _component_content_optimisation_table_new = _resolveComponent("content-optimisation-table-new");
  const _component_content_optimisation_table_new_with_parents = _resolveComponent("content-optimisation-table-new-with-parents");
  const _component_app_pagination = _resolveComponent("app-pagination");
  const _component_omny_ui_layout = _resolveComponent("omny-ui-layout");
  const _component_app_card_seo = _resolveComponent("app-card-seo");
  const _component_seo_bulk_modal = _resolveComponent("seo-bulk-modal");
  return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives(_createVNode(_component_app_card_seo, {
    loading: $data.dataLoading,
    "min-height": 300,
    scrollable: false,
    hasBorder: false,
    pushModal: _ctx.pushModal,
    onBack: $options.onPushModalCancel
  }, {
    default: _withCtx(() => [_createVNode(_component_omny_ui_layout, {
      contentPadding: "0",
      showPagination: true
    }, {
      "topbar-contents": _withCtx(() => [_createVNode(_component_seo_top_section, {
        hideNavigationTabs: $data.hideNavigationTabs,
        onPushModal: $options.onPushModal,
        onChangeTab: $options.onChangeTab,
        onPushSubmitModifedContents: $options.onPushModalSubmitModifiedContents
      }, null, 8, ["hideNavigationTabs", "onPushModal", "onChangeTab", "onPushSubmitModifedContents"])]),
      "topbar-sub": _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_app_input, {
        class: "seo-search-input",
        modelValue: $data.search,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.search = $event),
        placeholder: "Filter items...",
        debounce: "300",
        v2: "",
        version: "search",
        onChange: $options.searchItem
      }, null, 8, ["modelValue", "onChange"])]), _createVNode(_component_feature, {
        name: "seoPushStatusFilterFeature"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.pushStatusFilters, status => {
          return _openBlock(), _createBlock(_component_seo_push_status_filter, {
            status: status.status,
            icon: status.icon,
            iconSize: status.iconSize,
            iconHoverColor: status.iconHoverColor,
            iconDefaultColor: status.iconDefaultColor,
            pushStatusList: $options.pushStatusListForStatus(status),
            statusClass: status.statusClass,
            loading: $data.dataLoading
          }, null, 8, ["status", "icon", "iconSize", "iconHoverColor", "iconDefaultColor", "pushStatusList", "statusClass", "loading"]);
        }), 256))])]),
        _: 1
      }), _createElementVNode("div", {
        class: "bulk-btn",
        onClick: _cache[1] || (_cache[1] = (...args) => $options.onBulkOpen && $options.onBulkOpen(...args))
      }, [_createVNode(_component_app_icon, {
        icon: "bulk-btn"
      }), _hoisted_4]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_content_export_drop_down, {
        isDownloadRunning: $data.isDownloadRunning,
        onDownloadContentCsv: _ctx.handleSelectionDownloadTypeCSV
      }, null, 8, ["isDownloadRunning", "onDownloadContentCsv"])])])]),
      pagination: _withCtx(() => [_createVNode(_component_app_pagination, {
        page: _ctx.page,
        "onUpdate:page": [_cache[2] || (_cache[2] = $event => _ctx.page = $event), $options.changePage],
        perPage: _ctx.perPage,
        "onUpdate:perPage": [_cache[3] || (_cache[3] = $event => _ctx.perPage = $event), $options.changeElements],
        total: $options.currentTotal,
        isParentView: _ctx.currentTab === 'content_optimisation_with_parent',
        isListingView: _ctx.currentTab === 'content_optimisation' || _ctx.pushModal
      }, null, 8, ["page", "perPage", "total", "isParentView", "isListingView", "onUpdate:page", "onUpdate:perPage"])]),
      default: _withCtx(() => [(_ctx.currentTab === 'content_optimisation' || _ctx.pushModal) && $data.isFilterReady ? (_openBlock(), _createBlock(_component_content_optimisation_table_new, {
        key: 0,
        onResetPagingValues: $options.onResetPagingValues,
        onDataLoading: $options.onDataLoading,
        onEditSingleItem: $options.onEditSingleItem,
        onPushStatusList: $options.onPushStatusList
      }, null, 8, ["onResetPagingValues", "onDataLoading", "onEditSingleItem", "onPushStatusList"])) : _createCommentVNode("", true), _ctx.currentTab === 'content_optimisation_with_parent' && $data.isFilterReady && !_ctx.pushModal ? (_openBlock(), _createBlock(_component_content_optimisation_table_new_with_parents, {
        key: 1,
        onResetPagingValues: $options.onResetPagingValues,
        onDataLoading: $options.onDataLoading,
        onEditSingleItem: $options.onEditSingleItem,
        onPushStatusList: $options.onPushStatusList
      }, null, 8, ["onResetPagingValues", "onDataLoading", "onEditSingleItem", "onPushStatusList"])) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  }, 8, ["loading", "pushModal", "onBack"]), [[_vShow, !$data.editSingleItem]]), $data.isBulkOpen ? (_openBlock(), _createBlock(_component_seo_bulk_modal, {
    key: 0,
    modelValue: $data.isBulkOpen,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.isBulkOpen = $event)
  }, null, 8, ["modelValue"])) : _createCommentVNode("", true)], 64);
}